import React from "react";

export default function StepHeaderS3({ title }) {
   return (
      <div className={`step-3-header mb-3`}>
         <p>{title}</p>
      </div>
   );
}
